import React from 'react';

const styles = {
    tablecellpadding: {
        padding: '1.5em 0'
    }
}

const DeleteAnnualReportFile = (props) => {
    if(props.currentAnnualReport && !props.currentAnnualReportInherited && props.user.type==="admin") {
        return (
            <a onClick={() => { if (window.confirm('Filen vil blive slettet permanent. Bemærk, at hvis der er menigheder, som er tilknyttet det konsoliderede årsregnskab, vil deres tilknytning til årsregnskabet også blive fjernet. Ønsker du at fortsætte?')) props._handleDeleteAnnualReportFileFromServer()}} style={{cursor: 'pointer'}}>
                <img alt="Slet årsregnskab og bilag" src="/images/assets/kryds.svg" title="Slet årsregnskab" />
            </a>
        )
    } else if (props.file) {
        return (
        	<a onClick={props._handleDeleteAnnualReportFile} style={{cursor: 'pointer'}}><img alt="Slet årsregnskab" src="/images/assets/kryds.svg" title="Slet årsregnskab" /></a>	
        )
    } else {
        return null;
    }
}

export default DeleteAnnualReportFile;


// WEBPACK FOOTER //
// ./src/modules/reports/DeleteAnnualReportFile.js